import { Component } from '@angular/core';
import { LanguageRouterLinkDirective } from 'src/app/shared/directives/language-router-link.directive';
import { ModalService } from '@indice/ng-components';
import { TranslocoDirective } from '@jsverse/transloco';
import { GeneralCallbackModal } from 'src/app/shared/components/general-callback-modal/general-callback-modal.component';

@Component({
  selector: 'app-financing-actions',
  standalone: true,
  imports: [TranslocoDirective,LanguageRouterLinkDirective],
  templateUrl: './financing-actions.component.html',
  styleUrl: './financing-actions.component.css',
})
export class FinancingActionsComponent {
  constructor(
    private modalService: ModalService,
  ) {}

    generalCallback() {
    const generalCallback = this.modalService.show(GeneralCallbackModal, {
      keyboard: true,
      class: 'h-dvh md:h-auto',
    });
  }
}
